import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setFieldsState } from '../../../actions/fieldsState';
import { FormField } from '../../../components/FormField';
import { PriceInput } from '../../../components/PriceInput';
import { selectMoneyBalance } from '../../../selectors/moneyBalance';
import { TThunkDispatch } from '../../../types/redux/thunk';

export const MoneyBalance: React.FC = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const moneyBalance = useSelector(selectMoneyBalance);

  const handleChange = React.useCallback(
    (value: number | null) => {
      dispatch(setFieldsState({ moneyBalance: value }));
    },
    [dispatch],
  );

  return (
    <FormField
      label="Сколько накопили?"
      description="Первый взнос должен быть больше 10%"
      data-name="MoneyBalanceFormField"
    >
      <PriceInput value={moneyBalance} onChange={handleChange} />
    </FormField>
  );
};
